import React from 'react'

export const RequiredIndicator = () => {
  return <div className="required-indicator">*</div>
}
